<script setup lang="ts">
    import { ref, computed } from 'vue';
    import { themeColors } from '../../theme'

    const props = defineProps(['question', 'no']);
    const emit = defineEmits(['nextQuestion'])

    const sliderValue = ref((props.question.min + props.question.max) / 2);
    const isFeedbackShown = ref(false);
    const feedbackText = ref('');
    function showFeedback() {
        isFeedbackShown.value = true;

        for (let i = 0; i < props.question.feedbacks.length; i++) {
            if (sliderValue.value >= props.question.feedbacks[i].min) {
                feedbackText.value = props.question.feedbacks[i].text;
            }
        }
    }

    function emitNextQuestion() {
        emit('nextQuestion');
    }

    const trackStyle = computed((v) => {
        const percent = (sliderValue.value - props.question.min) / (props.question.max - props.question.min) * 100;
        return {
            background: `linear-gradient(to right, ${themeColors.primary['400']} 0%,
            ${themeColors.primary['500']} ${percent}%, ${themeColors.gray['200']} ${percent}%, ${themeColors.gray['200']} 100%)`
        }
    });
</script>

<template>
    <div class="h-full">
        <div v-if="isFeedbackShown === false">
            <h3 v-html="props.question.title"></h3>
            <div v-html="props.question.description"></div>

            <div class="mt-4" v-html="props.question.questionText"></div>
            <input type="range" v-model="sliderValue" class="mt-4 w-full slider"  :style="trackStyle"
                   :min="props.question.min" :max="props.question.max" :step="props.question.step" >
            <div class="font-bold">{{ props.question.outputTitle }}: <span class="onboarding-slider-output">{{ sliderValue }}</span></div>

            <button class="btn btn-primary mt-8" @click="showFeedback">Devam Et</button>
        </div>
        <div v-else>
            <img src="https://tll.mit.edu/wp-content/uploads/2020/09/absolutvision-82TpEld0_e4-unsplash-scaled-e1600182388853-2048x1024.jpg"
                 class="w-64 mb-4"  />
            <div class="font-bold" v-html="feedbackText"></div>
            <div v-if="props.question.feedbackExtraText" class="font-bold mt-4" v-html="props.question.feedbackExtraText"></div>

            <button class="btn btn-primary mt-8" @click="emitNextQuestion">Devam Et</button>
        </div>
    </div>
</template>

<style scoped>
.slider {
    @apply w-full h-3 bg-transparent rounded-full border-gray-800 border cursor-pointer appearance-none ;

    &::-webkit-slider-thumb {
        @apply -mt-0.5 w-5 h-5 bg-secondary rounded-full border-2 border-white shadow appearance-none;
    }

    &::-moz-range-thumb {
        @apply -mt-0.5 w-5 h-5 bg-secondary rounded-full border-2 border-white shadow appearance-none;
    }

    &::-moz-range-track {
        @apply h-2 bg-primary-default rounded-full;
    }
}
</style>
